import React, { useEffect, useState } from "react";

const SingleItem = ({ data }) => {
  const [livePrice, setLivePrice] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData();
    }, 1000);
    return () => clearInterval(interval);
  }, [livePrice]);

  const fetchData = async () => {
    if (data !== null) {
      if (data?.market === "Crypto" && data?.crypto_market_id) {
        fetch(
          `https://api.massive.com/v2/snapshot/locale/global/markets/crypto/tickers/X:${data?.crypto_market_id?.Symbol}${data?.crypto_market_id?.currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data?.ticker) {
              setLivePrice(data?.ticker);
            }
            if (loading) {
              setLoading(false);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      }
      if ((data?.market === "Forex" && data?.forex_market_id)) {
        fetch(
          `https://api.massive.com/v2/snapshot/locale/global/markets/forex/tickers/C:${data?.forex_market_id?.base_currency}${data?.forex_market_id?.quote_currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data?.ticker) {
              setLivePrice(data?.ticker);
            }
            if (loading) {
              setLoading(false);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      }
      if ((data?.market === "Metal" && data?.metal_market_id)) {
        fetch(
          `https://api.massive.com/v2/snapshot/locale/global/markets/forex/tickers/C:${data?.metal_market_id?.symbol}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data?.ticker) {
              setLivePrice(data?.ticker);
            }
            if (loading) {
              setLoading(false);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      }
      if (data?.market === "Stock" && data?.stock_market_id) {
        fetch(
          `https://api.massive.com/v2/snapshot/locale/us/markets/stocks/tickers/${data?.stock_market_id?.symbol}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data?.ticker) {
              setLivePrice(data?.ticker);
            }
            if (loading) {
              setLoading(false);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      }
    }
  };

  if (loading) {
    return<></>;
  }
  return (
    <>
      <div className="row popular-market-list">
        <div className="col-6">
          <h6>
            {data?.name}
            <span>/{(data?.crypto_market_id && `${data?.crypto_market_id?.Symbol}${data?.crypto_market_id?.currency}`) ||
              (data?.forex_market_id &&
                `${data.forex_market_id.base_currency}/${data.forex_market_id.quote_currency}`) ||
              data?.metal_market_id?.symbol ||
              data?.stock_market_id?.symbol}</span>
          </h6>
        </div>
        <div className="col-6 ">
          <div className="row popular-market-list-right">
            <div className="col-6"></div>
            <div className="col-6 ">
              <h6>
                {livePrice?.lastQuote?.a || livePrice?.lastTrade?.p ? "$" : ""}

                {data?.market === "Forex" &&
                  !isNaN(livePrice?.lastQuote?.a) &&
                  parseFloat(livePrice?.lastQuote?.a) +
                  parseFloat(data?.forex_market_id?.price)}

                {data?.market === "Metal" &&
                  !isNaN(livePrice?.lastQuote?.a) &&
                  parseFloat(livePrice?.lastQuote?.a) +
                  parseFloat(data?.metal_market_id?.price)}

                {data?.market === "Crypto" &&
                  !isNaN(livePrice?.lastTrade?.p) &&
                  parseFloat(livePrice?.lastTrade?.p) +
                  parseFloat(data?.crypto_market_id?.price)}

                {data?.market === "Stock" &&
                  !isNaN(livePrice?.lastTrade?.p) &&
                  parseFloat(livePrice?.lastTrade?.p) +
                  parseFloat(data?.stock_market_id?.price)}

                {livePrice?.lastQuote?.a === 0 ? (
                  <div className="market-closed">closed</div>
                ) : (
                  !livePrice?.lastQuote?.a &&
                  !livePrice?.lastTrade?.p && (
                    <div className="market-closed">closed</div>
                  )
                )}
              </h6>
            </div>
            {/* <div className="col-6 d-flex justify-content-end align-items-center">
              {LiveData?.todaysChangePerc < 0 ? (
                <span className="btn-2 bg-danger">
                  {parseFloat(LiveData?.todaysChangePerc).toFixed(2)}%
                </span>
              ) : (
                <span className="btn-2">
                  {parseFloat(LiveData?.todaysChangePerc).toFixed(2)}%
                </span>
              )}
            </div> */}
          </div>
        </div>
      </div>
    </>
  );

  ///////////////////////////////////////////////////////////////////////////

  // if (livePrice && livePrice[index]?.bid) {
  //   return (
  //     <>
  //       <div className="row popular-market-list">
  //         <div className="col-6">
  //           <h6>
  //             {data?.name}
  //             <span>/{data?.currency}</span>
  //           </h6>
  //         </div>
  //         <div className="col-6 ">
  //           <div className="row popular-market-list-right text-end">
  //             <div className="col-12 ">
  //               <h6>{livePrice[index]?.bid}$</h6>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </>
  //   );
  // }
};

export default SingleItem;
